import React, { useEffect } from "react";
import { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { getAllUser, delete_user, edit_user } from "../services/web/webServices";
import { Store } from "react-notifications-component";
import { Form, Formik, Field, ErrorMessage } from "formik";
import FileInput from "../components/FileInput";
import {
  // Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';

import { useTheme } from "@mui/material/styles";
import {
  MySelect,
  MyTextInput,
} from "../services/authentication/inputServices";
import * as Yup from "yup";
import Loader from "../components/Helpper/Loader";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
function UserManagements() {
  const theme = useTheme();
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const [select, setSelection] = useState([]);
  const [getLoader, setLoader] = useState(true);
  const [getButton, setButton] = useState(true);
  const [detailModal, setUserDetailModal] = useState([]);
  const [userDetail, setUserDetail] = useState([]);
  const [mainUserDetail, setMainUsersDetail] = useState([]);
  const [search, setSearch] = useState("");
  const [showEdit, setShowEdit] = useState(false);
  const [getbutton, setbutton] = useState(false);
  const [updateUserId, setUpdateUserId] = useState(null);
  const [updateUserData, setUpdateUserData] = useState([]);
  const [active, setActive] = React.useState('');
  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (params) => {
    setUserDetailModal(params);
    setShow(true);
  };
  const handleShow3 = (params) => {
    setUpdateUserId(params.row.id);
    setUpdateUserData(params);
    // setPlacesRowData(params);
    setShowEdit(true);
  };

  const handleClose3 = () => {
    setShowEdit(false);
  };

  const handleChange1 = (event) => {
    setActive(event.target.value);
  };

  const onDelete = (params) => () => {
    if (window.confirm("Are you sure you want to delete the user?")) {
      delete_user(params.row.id)
        .then((res) => {
          Store.addNotification({
            title: "Success",
            message: res?.data?.message,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });
          getAllUser()
            .then((res) => {
              const users = Array.isArray(res?.data?.user) ? res.data.user : [];
              setUserDetail(
                users.map((el, index) => ({
                  ...el,
                  id: el.id,
                  i: index,
                }))
              );
              setMainUsersDetail(
                users.map((el, index) => ({
                  ...el,
                  id: el.id,
                  i: index,
                }))
              );
            })

            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const columns = [
    {
      field: "sno",
      headerName: "S.NO.",
      filterable: false,
      renderCell: (index) => `${index.row.i + 1}`,
      width: 100,
    },
    {
      field: "firstName",
      headerName: "First name",
      width: 150,
    },

    {
      field: "email",
      headerName: "Email",
      width: 170,
    },
    {
      field: "avatar",
      headerName: "Avatar",
      width: 110,
      renderCell: (params) => {
        return (
          <div>
            {params?.row?.avatar == null ? (
              <img
                className="circular_image"
                style={{ width: "45px", height: 45, borderRadius: 45 / 2 }}
                src="./images/profile.jpg"
                alt="Not Found "
              />
            ) : (
              <img
                className="circular_image"
                style={{ width: 45, height: 45, borderRadius: 45 / 2 }}
                src={params?.row?.avatar}
                alt=""
              />
            )}
          </div>
        );
      },
    },
    {
      field: "fullName",
      headerName: "Full name",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 150,
      valueGetter: (value, row) =>
        `${row.firstName || ""} ${row.lastName || ""}`,
    },
    {
      field: 'status',
      headerName: 'Status',
      renderCell: (params) => {
        if (params.status == "active") {
          return <>{'Active'} </>;
        }
        if (params.status == "inActive") {
          return <>{'In-Active'} </>;
        }
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 250,
      renderCell: (params) => {
        return (
          <>
            <Button
              style={{
                backgroundColor: "#64A433",
                border: "none",
                marginRight: "5px",
              }}
              onClick={() => handleShow(params)}
            >
              <i className="fas fa-eye"></i>
            </Button>
            <Button
              style={{
                backgroundColor: "#64A433",
                border: "none",
                marginRight: "5px",
              }}
              onClick={() => handleShow3(params)}
            >
              <i className="fas fa-edit"></i>
            </Button>
            <Button
              color="error"
              onClick={onDelete(params)}
              style={{ backgroundColor: "#64A433", border: "none" }}
            >
              <i className="fa fa-trash" aria-hidden="true"></i>
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    setLoader(true);
    getAllUser()
      .then((res) => {
        const users = Array.isArray(res?.data?.user) ? res.data.user : [];
        setUserDetail(
          users.map((el, index) => ({
            ...el,
            id: el.id,
            i: index,
          }))
        );
        setMainUsersDetail(
          users.map((el, index) => ({
            ...el,
            id: el.id,
            i: index,
          }))
        );
        setLoader(false);
      })

      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }, []);
  const handleSearch = (text) => {
    const keyword = text;
    if (keyword === "") {
      setUserDetail(mainUserDetail);
    } else {
      const filteredData = mainUserDetail.filter(
        (user) =>
          user.firstName.toLowerCase().includes(keyword) ||
          user.email.toLowerCase().includes(keyword)
      );
      setUserDetail(filteredData);
    }
  };
  const css = `
    .form-container {
  display: flex;
  gap: 16px; 
  padding:20px
}

.form-group {
  flex: 1; /* Ensures that each form group takes equal space */
}
  label {
  color: #555659; 
}
  .form-label {
  margin-bottom: 5px;
  display: block;
  font-weight: bold;
}
  .form-submit {
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.form-submit:hover {
  background-color: #45a049;
}

  
  `;

  return (
    <>
      <style>{css}</style>
      <div className="grid-container">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
        <Header OpenSidebar={OpenSidebar} pageName="User Management" />

        <div
          style={{
            gridArea: "main",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            // margin: "0 150px 150px",
            margin: "0 90px 150px",
          }}
        >
          <div
            style={{
              margin: "30px",
              display: "flex",
              alignItems: "center", // Center items vertically
              justifyContent: "flex-end", // Align items to the end of the container
              marginRight: "50px", // Adjust margin to your preference
            }}
          >
            <input
              type="text"
              onChange={(event) => {
                setSearch(event.target.value.toLowerCase());
                handleSearch(event.target.value.toLowerCase());
              }}
              style={{
                padding: "12px", // Increased padding for better touch feel
                borderRadius: "20px",
                border: "2px solid #ccc",
                fontSize: "16px",
                width: "300px",
                marginLeft: "600px",
                outline: "none",
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                transition: "border-color 0.3s ease",
              }}
              placeholder="Search..."
            />
          </div>

          <div
            style={{
              width: "100%",
              backgroundColor: "white",
              paddingBottom: "100px",
            }}
          >
            <Box
              sx={{
                boxShadow: 7,
                height: 500,
                minHeight: 500,
                position: "relative",
                minWidth: "700px"
                // padding:"10px"
              }}
            >
              {getLoader ? (
                <Loader />
              ) : userDetail.length > 0 ? (
                <>
                  <h2>{select.map((val) => val._id)}</h2>
                  <DataGrid
                    rows={userDetail}
                    columns={columns}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                      },
                    }}
                    pageSizeOptions={[10, 25]}
                    onSelectionChange={(newSelection) => {
                      setSelection(newSelection.rows);
                    }}
                    sx={{
                      "& .MuiDataGrid-row:nth-of-type(odd)": {
                        backgroundColor: theme.palette.action.hover, // Light grey background
                      },
                      "& .MuiDataGrid-cell:last-child": {
                        border: 0, // Hide the last cell border
                      },
                    }}
                  />
                </>
              ) : search != "" ? (
                <p style={{ fontSize: "30px", padding: "30px" }}>
                  No User Found!!
                </p>
              ) : (
                <p style={{ fontSize: "30px", padding: "30px" }}>
                  No data found.
                </p>
              )}
            </Box>
            <Modal show={show} onHide={handleClose} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>User Detail</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Formik
                  initialValues={{
                    firstName: detailModal?.row?.firstName
                      ? detailModal?.row?.firstName
                      : "",
                    lastName: detailModal?.row?.lastName
                      ? detailModal?.row?.lastName
                      : "",
                    email: detailModal?.row?.email
                      ? detailModal?.row?.email
                      : "",
                    mobileNumber: detailModal?.row?.mobileNumber
                      ? detailModal?.row?.mobileNumber
                      : "",
                    avatar: "",
                  }}
                  validationSchema={Yup.object({
                    firstName: Yup.string(),
                    lastName: Yup.string(),
                    email: Yup.string(),
                  })}
                  onSubmit={(values, { resetForm }) => {
                    setButton(false);

                    values
                      .then((res) => {
                        setButton(true);

                        Store.addNotification({
                          title: "Success",
                          message: res.data?.message,
                          type: "success",
                          insert: "top",
                          container: "top-right",
                          animationIn: ["animate__animated", "animate__fadeIn"],
                          animationOut: [
                            "animate__animated",
                            "animate__fadeOut",
                          ],
                          dismiss: {
                            duration: 5000,
                            onScreen: true,
                          },
                        });

                        handleClose();
                      })
                      .catch((error) => {
                        setButton(true);
                        if (error) {
                          Store.addNotification({
                            title: "Error!",
                            message: error?.response?.data?.message,
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: [
                              "animate__animated",
                              "animate__fadeIn",
                            ],
                            animationOut: [
                              "animate__animated",
                              "animate__fadeOut",
                            ],
                            dismiss: {
                              duration: 5000,
                              onScreen: true,
                            },
                          });
                        }
                      });
                  }}
                >
                  {(props) => (
                    <Form>
                      <div className="form-container">
                        <div className="form-group">
                          <label className="form-label">First Name</label>
                          <MyTextInput
                            type="text"
                            id="firstName"
                            name="firstName"
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="form-group">
                          <label className="form-label">Last Name</label>
                          <MyTextInput
                            type="text"
                            id="lastName"
                            name="lastName"
                            className="form-control"
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="form-container">
                        <div className="form-group">
                          <label className="form-label">Email</label>
                          <MyTextInput
                            type="email"
                            id="email"
                            name="email"
                            className="form-control"
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="form-container">
                        <div>
                          <div
                            className="form-group"
                            style={{ height: "300px", width: "500px" }}
                          >
                            <label className="form-label">
                              Profile Picture :{" "}
                            </label>

                            {detailModal?.row?.avatar ? (
                              <img
                                src={detailModal?.row?.avatar}
                                className=" w-50 p-3"
                                alt=""
                              />
                            ) : (
                              <span> No Profile Picture Found!</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal show={showEdit} onHide={handleClose3} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Edit User Detail</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Formik
                  initialValues={{
                    firstName: updateUserData?.row?.firstName
                      ? updateUserData?.row?.firstName
                      : "",
                    lastName: updateUserData?.row?.lastName
                      ? updateUserData?.row?.lastName
                      : "",
                    email: updateUserData?.row?.email
                      ? updateUserData?.row?.email
                      : "",
                    avatar: null,
                    status: updateUserData?.row?.status ? updateUserData?.row?.status
                      : "",
                  }}
                  validationSchema={Yup.object({
                    firstName: Yup.string()
                      .required("First Name is required")
                      .min(2, "First Name must be at least 2 characters")
                      .max(20, "First Name must be 20 characters or less"),

                    lastName: Yup.string()
                      .required("Last Name is required")
                      .min(2, "Last Name must be at least 2 characters")
                      .max(20, "Last Name must be 20 characters or less"),

                    email: Yup.string()
                      .required("Email is required")
                      .email("Invalid email format"),

                    avatar: Yup.mixed().nullable(),
                  })}
                  onSubmit={(values, { resetForm }) => {

                    let formData = new FormData();
                    formData.append("firstName", values.firstName);
                    formData.append("lastName", values.lastName);
                    formData.append("email", values.email);

                    if (values.avatar && values.avatar.length > 0) {
                      formData.append("avatar", values.avatar[0]);
                    }
                    if (active) {
                      formData.append('status', active);
                    }
                    setbutton(true);
                    edit_user(updateUserId, formData)
                      .then((res) => {
                        Store.addNotification({
                          title: "Success",
                          message: res?.data?.msg,
                          type: "success",
                          insert: "top",
                          container: "top-right",
                          animationIn: ["animate__animated", "animate__fadeIn"],
                          animationOut: ["animate__animated", "animate__fadeOut"],
                          dismiss: {
                            duration: 3000,
                            onScreen: true,
                          },
                        });
                        resetForm({ formData: "" });
                        getAllUser()
                          .then((res) => {
                            const users = Array.isArray(res?.data?.user) ? res.data.user : [];
                            setUserDetail(
                              users.map((el, index) => ({
                                ...el,
                                id: el.id,
                                i: index,
                              }))
                            );
                            setMainUsersDetail(
                              users.map((el, index) => ({
                                ...el,
                                id: el.id,
                                i: index,
                              }))
                            );
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                        handleClose3();
                        setbutton(false);
                      })
                      .catch((err) => {
                        console.log(err);
                        if (err) {
                          Store.addNotification({
                            title: "Error!",
                            message: err?.response?.data?.msg,
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animate__animated", "animate__fadeIn"],
                            animationOut: ["animate__animated", "animate__fadeOut"],
                            dismiss: {
                              duration: 3000,
                              onScreen: true,
                            },
                          });
                          setbutton(false);
                        }
                      });
                  }}
                >
                  <Form>
                    <div className="form-container">
                      <div className="form-group">
                        <label className="form-label">First Name</label>
                        <MyTextInput
                          type="text"
                          id="firstName"
                          name="firstName"
                          className="form-control"
                        />

                      </div>
                      <div className="form-group">
                        <label className="form-label">Last Name</label>
                        <MyTextInput
                          type="text"
                          id="lastName"
                          name="lastName"
                          className="form-control"

                        />

                      </div>
                    </div>
                    <div className="form-container">
                      <div className="form-group">
                        <label className="form-label">Email</label>
                        <MyTextInput
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"

                        />

                      </div>

                      <div className='form-group'>
                        <label className="form-label">Status</label>
                        <RadioGroup
                          aria-label='gender'
                          name='gender1'
                          defaultValue={updateUserData?.row?.status}
                          onChange={handleChange1}
                        >
                          <FormControlLabel
                            value='Active'
                            control={<Radio />}
                            label='Active'
                          />
                          <FormControlLabel
                            value='InActive'
                            control={<Radio />}
                            label='In-Active'
                          />
                        </RadioGroup>
                      </div>
                    </div>

                    <div className="form-container">

                      <div className="form-group">
                        {updateUserData?.row?.avatar ? (
                          <img
                            src={updateUserData?.row?.avatar}
                            style={{ height: "180px", width: "180px", margin: "10px" }}
                            // className="w-50 p-3"
                            alt=""
                          />
                        ) : (
                          <span> No Profile Image Found!</span>
                        )}
                        <label htmlFor="avatar" className="form-label">
                          Profile Image
                        </label>
                        <Field name="avatar"  accept="image/*" component={FileInput} />
                        <ErrorMessage name="avatar" component="div" className=" text-danger" />
                      </div>
                    </div>

                    {!getbutton ? (
                      <Button type="submit" className="form-submit">
                        Update
                      </Button>
                    ) : (
                      <Button type="submit" className="form-submit" disabled>
                        Please Wait!!
                      </Button>
                    )}
                  </Form>
                </Formik>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose3}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>

          </div>
        </div>
      </div>
    </>
  );
}

export default UserManagements;

// style={{
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   // minHeight: "100vh",
// }}
